<div id="what" class="{{activeWhat}}">
    <audio id="audioSection" controls autoplay loop hidden="hidden">
        <source autoplay="true" src="../../assets/audio/inside.mp3" type="audio/mp3">
        <!-- Your browser does not support the audio element. -->
    </audio>
    <section id="sec1">
        <div class="land landscape" id="landscape">           
            <!-- desktop and tablets -->
            <div class="hide-on-small-only tabletAndDesktop">
                <div class="row box-text">
                    <div class="col l6 offset-l6 hide-on-med-only">
                        <h4 class="white-text text-center text-section">
                            Queremos colaborar con marcas y agencias para crear memorbales experiencias
                        </h4>
                    </div>
                    <div class="col m6 offset-m6 hide-on-large-only">
                        <h5 class="white-text text-center text-section">
                            Queremos colaborar con marcas y agencias para crear memorbales experiencias
                        </h5>
                    </div>
                </div>
                <!-- landscape -->
                <div class="keyart" id="parallax1">
                    <img class="keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/desktop/2column.png"  data-speed="28" alt="">
                    <!-- elevator -->
                    <div class="hide-on-large-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope-m.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people-m.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box-m.png">
                    </div>
                    <div class="hide-on-med-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box.png">
                    </div>
                    <!-- cave walls  -->
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/desktop/1leftBack.png" data-speed="8" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/desktop/1rightBack.png" data-speed="8" alt="">
                    
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/desktop/2ice.png" data-speed="14" alt="">
                    <img class="hide-on-large-only keyart_layer parallax responsive-img base zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/desktop/2ice.png" data-speed="14" alt="">
                    
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/desktop/2leftFront.png" data-speed="8" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/desktop/2rightFront.png" data-speed="8" alt="">
                    
                    <!-- cave rocks -->
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zFront landscapeAnimateFirst animated" src="assets/img/what/sec1/desktop/3.png" data-speed="8" alt="">
                    <img class="hide-on-large-only keyart_layer parallax responsive-img base zFront landscapeAnimateFirst animated" src="assets/img/what/sec1/desktop/3.png" data-speed="8" alt="">
                    
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateFirst animated" src="assets/img/what/sec1/desktop/4.png" data-speed="14" alt="">
                    <img class="keyart_layer parallax responsive-img up zFront" src="assets/img/what/sec1/desktop/1.png" data-speed="4">
                </div>

            </div>
            
            <!-- mobile -->
            <div class="hide-on-med-and-up mobileOnly relative"> 
                <div class="row box-text1s">
                    <div class="col s12">
                        <h4 class="white-text text-center text-section">
                            Queremos colaborar con marcas y agencias para crear memorbales experiencias
                        </h4>
                    </div>
                </div>
                <!-- landscape -->
                <div class="keyart" id="parallax1m">
                    <img class="keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/mobile/2column.png"  data-speed="28" alt="">
                    <img class="keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/mobile/2leftBack.png" data-speed="8" alt="">
                    <img class="keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/mobile/2rightBack.png" data-speed="8" alt="">
                    <img class="keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/mobile/2leftFront.png" data-speed="8" alt="">
                    <img class="keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/mobile/2rightFront.png" data-speed="8" alt="">
                    <!-- elevator -->
                    <div class="elevatorS z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/mobile/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/mobile/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/mobile/elevator/box.png">
                    </div>
                    <!-- cave walls  -->
                    <img class="hide-on-large-only keyart_layer parallax responsive-img up zBack left landscapeAnimateSecond animated" src="assets/img/what/sec1/mobile/2ice.png" data-speed="14" alt="">
                    
                    <!-- cave rocks -->
                    <img class="hide-on-large-only keyart_layer parallax responsive-img up zFront landscapeAnimateFirst animated" src="assets/img/what/sec1/mobile/3.png" data-speed="8" alt="">
                    
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateFirst animated" src="assets/img/what/sec1/mobile/4.png" data-speed="14" alt="">
                    <img class="keyart_layer parallax responsive-img up zFront" src="assets/img/what/sec1/mobile/1.png" data-speed="4">
                </div>
            </div>
    
        </div>

        
    </section>

    <section id="sec2">
        <div class="land landscape2" id="landscape2">
            
            
            <div class="hide-on-small-only tabletAndDesktop">
                <div class="row box-text">
                    <div class="col l5 offset-l6 hide-on-med-only">
                        <h4 class="white-text text-center text-section2">
                            Piense en nosotros como una aliado creativo
                        </h4>
                    </div>
                    <div class="col m5 offset-m6 hide-on-large-only">
                        <h5 class="white-text text-center text-section2">
                            Piense en nosotros como una aliado creativo
                        </h5>
                    </div>
                </div>
                <!-- landscape -->
                <div class="keyart" id="parallax2">
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec2/desktop/1iceUp.png"  data-speed="0" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up left zBack landscapeAnimateSecond animated" src="assets/img/what/sec2/desktop/1leftBack.png"  data-speed="0" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec2/desktop/1rightBack.png"  data-speed="0" alt="">
                    <!-- elevator -->
                    <div class="hide-on-large-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope-m.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people-m.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box-m.png">
                    </div>
                    <div class="hide-on-med-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box.png">
                    </div>
                    
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec2/desktop/1wallDown.png"  data-speed="0" alt="">
                    <img class="hide-on-large-only keyart_layer parallax responsive-img base zFront landscapeAnimateSecond animated" src="assets/img/what/sec2/desktop/1wallDown.png"  data-speed="1" alt="">
                </div>

            </div>
    
            <div class="hide-on-med-and-up mobileOnly relative">
                <div class="row box-text1s">
                    <div class="col s12">
                        <h4 class="white-text text-center text-section">
                            Piense en nosotros como un 
                            aliado creativo
                        </h4>
                    </div>
                </div>
                <!-- mobile -->
                <div class="keyart" id="parallax2m">
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec2/mobile/cielingIce.png"  data-speed="0" alt="">
                    <img class="keyart_layer parallax responsive-img up left zBack landscapeAnimateSecond animated" src="assets/img/what/sec2/mobile/leftWall.png"  data-speed="4" alt="">
                    <img class="keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec2/mobile/rightWall.png"  data-speed="4" alt="">
                    <!-- elevator -->
                    <div class="elevatorS z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/mobile/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/mobile/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/mobile/elevator/box.png">
                    </div>
                    
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec2/mobile/column.png"  data-speed="3" alt="">
                </div>
            </div>
    
        </div>
    </section>

    <section id="sec3">
        <div class="land landscape3" id="landscape3">
            
            
            <div class="hide-on-small-only tabletAndDesktop">
                <div class="row box-text3">
                    <!-- large -->
                    <div class="col l6 offset-l5 hide-on-med-only">
                        <h4 class="text-center text-section">
                            SERVICIOS
                        </h4>
                    </div>
                    <div class="col l4 offset-l6 hide-on-med-only">
                        <div class="col l12" *ngFor="let serv of services">
                            <h5 class="skill text-center">{{serv.name}}</h5>
                        </div>
                    </div>
                    <!-- medium -->
                    <div class="col m6 offset-m6 hide-on-large-only">
                        <h5 class="text-center text-section">
                            SERVICIOS
                        </h5>
                    </div>
                    <div class="col m6 offset-m6 hide-on-large-only">
                        <div class="col m12" *ngFor="let serv of services">
                            <h5 class="skill text-center">{{serv.name}}</h5>
                        </div>
                    </div>
                </div>
                <!-- landscape -->
                <div class="keyart" id="parallax3">
                    
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/1wallUp.png"  data-speed="0" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/rightHole.png"  data-speed="3" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/cieling.png"  data-speed="0" alt="">
                    
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/diamondsBack.png"  data-speed="0" alt="">

                    <!-- elevator -->
                    <div class="hide-on-large-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope-m.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people-m.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box-m.png">
                    </div>
                    <div class="hide-on-med-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box.png">
                    </div>
                    
                    <img class="hide-on-large-only keyart_layer parallax responsive-img base right zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/diamondsFront.png"  data-speed="0" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/diamondsFront.png"  data-speed="2" alt="">
                    
                    <img class="hide-on-large-only keyart_layer parallax responsive-img base zFront landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/personFloor.png"  data-speed="0" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec3/desktop/personFloor.png"  data-speed="0" alt="">

                </div>

            </div>
    
            <div class="hide-on-med-and-up mobileOnly relative"> 
                <div class="row box-text3">
                    <!-- large -->
                    <div class="col s12">
                        <h4 class="text-center text-section">
                            SERVICIOS
                        </h4>
                    </div>
                    <div class="col s12">
                        <div class="col s12" *ngFor="let serv of services">
                            <h5 class="skill text-center">{{serv.name}}</h5>
                        </div>
                    </div>
                </div>
                <div class="keyart" id="parallax3m">
                    
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec3/mobile/1wallUp.png"  data-speed="0" alt="">
                    <img class="keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/mobile/rightHole.png"  data-speed="2" alt="">
                    <img class="keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/mobile/cieling.png"  data-speed="0" alt="">
                    
                    <img class="keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/mobile/diamondsBack.png"  data-speed="0" alt="">

                    <!-- elevator -->
                    <div class="elevatorS z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/mobile/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/mobile/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/mobile/elevator/box.png">
                    </div>
                    
                    <img class="keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec3/mobile/diamondsFront.png"  data-speed="0" alt="">
                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec3/mobile/personFloor.png"  data-speed="1" alt="">
                    
                </div>
            </div>
    
        </div>
    </section>

    <section id="sec4">
        <div class="land landscape4" id="landscape4">
            
            
            <div class="hide-on-small-only tabletAndDesktop">

                <div class="row box-text4">
                    <!-- large -->
                    <div class="col l6 offset-l5 hide-on-med-only">
                        <h4 class="text-center text-section">
                            Nuestra experiencia
                        </h4>
                    </div>
                    <div class="col l4 offset-l6 hide-on-med-only">
                        <div class="col l6">
                            <h5 class="brand text-center">Ayg Equipos Veterinarios</h5>
                        </div>
                        <div class="col l6">
                            <h5 class="brand text-center">LM Maskotas</h5>
                        </div>
                    </div>
                    <div class="col l6 offset-l5 hide-on-med-only">
                        <h6 class="text-center white-text">
                            Son unas de las marcas con las que hemos trabajado
                        </h6>
                    </div>
                    <!-- medium -->
                    <div class="col m6 offset-m6 hide-on-large-only">
                        <h4 class="text-center text-section">
                            Nuestra experiencia
                        </h4>
                    </div>
                    <div class="col m6 offset-m6 hide-on-large-only">
                        <div class="col m6">
                            <h5 class="brand text-center">Ayg Equipos Veterinarios</h5>
                        </div>
                        <div class="col m6">
                            <h5 class="brand text-center">LM Maskotas</h5>
                        </div>
                    </div>
                    <div class="col m6 offset-m6 hide-on-large-only">
                        <h6 class="text-center white-text">
                            Son unas de las marcas con las que hemos trabajado
                        </h6>
                    </div>
                </div>
               
                <!-- landscape -->
                <div class="keyart" id="parallax4">

                    <!-- light -->
                    <div class="light">
                        <img class="l4 hide-on-med-only keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/light/4.png"  data-speed="0" alt="">
                        <img class="l3 keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/light/3.png"  data-speed="0" alt="">
                        <img class="l2 keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/light/2.png"  data-speed="0" alt="">
                        <img class="l1 keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/light/1.png"  data-speed="0" alt="">
                    </div>

                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/1cieling.png"  data-speed="0" alt="">
                    <img class="keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/wallRight.png"  data-speed="1" alt="">


                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/trees.png"  data-speed="0" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/temple.png"  data-speed="0" alt="">
                    <img class="hide-on-med-only keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/wayRocks.png"  data-speed="0" alt="">
                    
                    <!-- elevator -->
                    <div class="hide-on-large-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope-m.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people-m.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box-m.png">
                    </div>
                    <div class="hide-on-med-only elevator z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/desktop/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/desktop/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/desktop/elevator/box.png">
                    </div>
                    
                    <img class="hide-on-med-only keyart_layer parallax responsive-img  up zFront landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/bigOneRock.png"  data-speed="0" alt="">
                    
                    <img class="hide-on-large-only keyart_layer parallax responsive-img  base zFront landscapeAnimateSecond animated" src="assets/img/what/sec4/desktop/templeMedium.png"  data-speed="0" alt="">
                    
                </div>
            </div>
    
            <div class="hide-on-med-and-up mobileOnly relative">
                <div class="row box-text4">
                    <!-- large -->
                    <div class="col s12">
                        <h4 class="text-center text-section white-text">
                            Nuestra experiencia
                        </h4>
                    </div>
                    <div class="col s12">
                        <div class="col s6">
                            <h5 class="brand text-center">Ayg Equipos Veterinarios</h5>
                        </div>
                        <div class="col s6">
                            <h5 class="brand text-center">LM Maskotas</h5>
                        </div>
                    </div>
                    <div class="col s12 ">
                        <h5 class="text-center white-text">
                            Son unas de las marcas con las que hemos trabajado
                        </h5>
                    </div>
                </div>
                <div class="keyart" id="parallax4m">
                    <!-- light -->
                    <div class="light">
                        <img class="l4 keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/mobile/light/4.png"  data-speed="0" alt="">
                        <img class="l3 keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/mobile/light/3.png"  data-speed="0" alt="">
                        <img class="l2 keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/mobile/light/2.png"  data-speed="0" alt="">
                        <img class="l1 keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/mobile/light/1.png"  data-speed="0" alt="">
                    </div>

                    <img class="keyart_layer parallax responsive-img up zFront landscapeAnimateSecond animated" src="assets/img/what/sec4/mobile/1cieling.png"  data-speed="0" alt="">
                    <img class="keyart_layer parallax responsive-img up right zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/mobile/wallRight.png"  data-speed="1" alt="">
                    <img class="keyart_layer parallax responsive-img up zBack landscapeAnimateSecond animated" src="assets/img/what/sec4/mobile/temple.png"  data-speed="0" alt="">

                    <!-- elevator -->
                    <div class="elevatorS z-middle">
                        <img class="responsive-img rope" src="assets/img/what/sec1/mobile/elevator/rope.png">
                        <img class="responsive-img people" src="assets/img/what/sec1/mobile/elevator/people.png">
                        <img class="responsive-img box" src="assets/img/what/sec1/mobile/elevator/box.png">
                    </div>
                </div>
            </div>
    
        </div>
    </section>
</div>